import React from 'react';

import { AwardList } from './AwardList.component';
import useUserBadges from '+/utils/hooks/useUserBadges';

export default (props) => {
  const userBadges = useUserBadges() || [];
  return <AwardList {...props} userBadges={userBadges} />;
};
